import Yup from '~/util/yup';
import { Form } from '~/shared/forms/Form';
import { TextFormField } from '~/shared/forms/controls/fields/text-fields/TextFormField';
import { TextAreaFormField } from '~/shared/forms/controls/fields/text-fields/TextAreaFormField';
import { useGoalsAndInterventionsWizard } from '../GoalsAndInterventionsWizardContext';
import { GoalDefinitionTypeEnum } from '@generated';

const validationSchema = Yup.object().shape({
	subject: Yup.string().nullable().label('Subject').required(),
	definitionText: Yup.string().nullable().label('Definition Text').required()
});

export function CustomGoalForm() {
	const { wizardState, existingGoals } = useGoalsAndInterventionsWizard();
	const customGoalCount = existingGoals.filter(x => x.goalDefinitionTypeId === GoalDefinitionTypeEnum.Custom).length;

	if (wizardState.selectedGoalOption !== 'custom') {
		throw new Error('CustomGoalForm can only be used when the selectedGoalOption is "custom"');
	}
	const initialValues =
		wizardState.selectedGoal && wizardState.selectedGoal.type === 'custom' && wizardState.selectedGoal.formValues
			? wizardState.selectedGoal.formValues
			: {
					subject: `Custom Goal #${customGoalCount + 1}`,
					definitionText: null
			  };

	return (
		<Form initialValues={initialValues} validationSchema={validationSchema} registryId="custom">
			<div className="w-full max-w-3xl space-y-4">
				<TextFormField name="subject" />
				<TextAreaFormField name="definitionText" />
			</div>
		</Form>
	);
}
